module.exports = __webpack_public_path__ + "static/media/enterprise-employers-02.12f09bf5.jpg";